package nl.volleyplanner.extensions

inline fun <T> T?.ifNull(defaultValue: () -> T) : T = this ?: defaultValue()